module.exports = require("./ur-IN.d.ts");